module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qnerv7-e2cda8267da86aab85711444bece25e6.jpg";